import { useSelector } from 'react-redux';
import { requestSucceeded } from 'redux-request-state/util/requestStateCheckers';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { CopyButton } from 'foundations-components/transitional/components/CopyButton';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { getTemplateInfoRequest } from 'ContentEditorUI/redux/selectors/requestStatesSelectors';
import { selectHasBlogAudioModuleInTemplate } from '../../redux/selectors/audioNarrationSelectors';
// @ts-expect-error not converted yet
import { getEditTemplateUrl } from '../../redux/selectors/postSettingsSelectors';
import { Flex } from 'foundations-components/components/Flex';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const NARRATION_KB_ARTICLE_URL = 'https://knowledge.hubspot.com/blog/use-the-post-narration-module';
const BLOG_AUDIO_MODULE_HUBL_SNIPPET = `{% module "blog_post_audio" path="@hubspot/blog_audio", overrideable=False %}`;
const TemplateModuleWarningMessage = ({
  message
}) => {
  const editTemplateUrl = useSelector(getEditTemplateUrl);
  return /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: message,
    elements: {
      UILink: Link
    },
    options: {
      editTemplateUrl,
      betaDocUrl: NARRATION_KB_ARTICLE_URL
    }
  });
};
export const TemplateModuleWarning = () => {
  const hasBlogAudioModule = useSelector(selectHasBlogAudioModuleInTemplate);
  const templateInfoLoaded = requestSucceeded(useSelector(getTemplateInfoRequest));
  const editTemplateUrl = useSelector(getEditTemplateUrl);
  if (!templateInfoLoaded || !editTemplateUrl) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {});
  }
  return hasBlogAudioModule ? null : /*#__PURE__*/_jsx(Alert, {
    type: "warning",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "audioNarration.settings.templateMissingModule.title"
    }),
    "data-test-id": "template-module-warning",
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "start",
      children: [/*#__PURE__*/_jsx(TemplateModuleWarningMessage, {
        message: "audioNarration.settings.templateMissingModule.description_jsx"
      }), /*#__PURE__*/_jsx(Flex, {
        flexShrink: 0,
        marginInlineStart: "200",
        children: /*#__PURE__*/_jsx(CopyButton, {
          size: "small",
          value: BLOG_AUDIO_MODULE_HUBL_SNIPPET,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "audioNarration.settings.copyHublSnippet"
          })
        })
      })]
    })
  });
};
export default TemplateModuleWarning;